import Cookies from "universal-cookie";

import * as types from "./actionTypes";

const cookies = new Cookies();

function openBusinessAccountStart() {
  return {type: types.BUSINESS_ACCOUNT_OPEN_START}
}

function openBusinessAccountDone() {
  return {type: types.BUSINESS_ACCOUNT_OPEN_DONE}
}

function openBusinessAccountFailed(error) {
  return {
    type: types.BUSINESS_ACCOUNT_OPEN_FAILED,
    payload: error
  }
}

export function openBusinessAccount(params) {
  return (dispatch, getState) => {
    const { user } = getState();
    if (!user) { return }

    const leadId = cookies.get('companyId');
    const apiUrl = `${process.env.REACT_APP_FCHUB_URL}/leads/${leadId}/business_account`

    dispatch(openBusinessAccountStart());

    return fetch(apiUrl, {
      method: "POST",
      body: JSON.stringify({ ...params }),
      headers: new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
      }),
      credentials: 'include'
    })
      .then(response => {
        if (response.status === 201) {
          return response.json()
        } else {
          return dispatch(openBusinessAccountFailed('Failed to open a business account'));
        }
      })
      .then(json => {
        if (json.id && json.success) {
          dispatch(openBusinessAccountDone());
        } else {
          dispatch(openBusinessAccountFailed('Failed to open a business account'));
        }
      })
      .catch(error => {
        openBusinessAccountFailed(error)
      });
  }
}

function getBusinessAccountConsentUrlStart() {
  return {type: types.BUSINESS_ACCOUNT_FETCH_CONSENT_START}
}

function getBusinessAccountConsentUrlDone() {
  return {type: types.BUSINESS_ACCOUNT_FETCH_CONSENT_DONE}
}

function getBusinessAccountConsenUrlFailed(error) {
  return {
    type: types.BUSINESS_ACCOUNT_FETCH_CONSENT_FAILED,
    payload: error
  }
}

export function getBusinessAccountConsentUrl() {
  return (dispatch, getState) => {
    const { user } = getState();
    if (!user) { return }

    const leadId = cookies.get('companyId');
    const apiUrl = `${process.env.REACT_APP_FCHUB_URL}/leads/${leadId}/netbank_consent`

    dispatch(getBusinessAccountConsentUrlStart());

    return fetch(apiUrl, {
      method: "POST",
      headers: new Headers({
        "Accept": "application/json",
        "Content-Type": "application/json",
      }),
      credentials: 'include'
    })
      .then(response => response.json())
      .then(json => {
        dispatch(getBusinessAccountConsentUrlDone());
        window.location.assign(json.consent_url)
      })
      .catch(error => {
        getBusinessAccountConsenUrlFailed(error)
      });
  }
}

function fetchBusinessAccountStateStart() {
  return {type: types.BUSINESS_ACCOUNT_FETCH_STATE_START}
}

function fetchBusinessAccountStateDone(payload) {
  return {
    type: types.BUSINESS_ACCOUNT_FETCH_STATE_DONE,
    payload
  }
}

function fetchBusinessAccountStateFailed(error) {
  return {
    type: types.BUSINESS_ACCOUNT_FETCH_STATE_FAILED,
    payload: error
  }
}

export function fetchBusinessAccountState(redirectToBank, onSuccess = () => {}, onError = () => {}) {
  return (dispatch, getState) => {
    const { user } = getState();
    if (!user) { return }

    const leadId = cookies.get('companyId');
    const apiUrl = `${process.env.REACT_APP_FCHUB_URL}/leads/${leadId}.json`;

    dispatch(fetchBusinessAccountStateStart());

    return fetch(apiUrl, {
      method: "GET",
      headers: new Headers({
        "Accept": "application/json",
      }),
      credentials: 'include',
      mode: 'no-cors',
    })
      .then(response => response.json())
      .then(json => {
        onSuccess();
        dispatch(fetchBusinessAccountStateDone(json));
      })
      .catch(error => {
        onError();
        dispatch(fetchBusinessAccountStateFailed(error));
        dispatch({
          type: "HANDLE_ERRORS",
          payload: error,
        })
        dispatch({ type: "LOADING_STOP" });
      });
  }
}



// WEBPACK FOOTER //
// ./src/features/business_account/actions.js